import { apiClient } from "../lib/apiClient";
import type { AuthUser } from "../types";

export interface ImpersonatorInfo {
  id: string;
  name: string;
  email: string;
}

export interface CurrentUserResponse {
  user: AuthUser | null;
  impersonatedBy: ImpersonatorInfo | null;
}

export async function fetchCurrentUser(): Promise<CurrentUserResponse> {
  const { data } = await apiClient.get<CurrentUserResponse>("/auth/me");
  return data;
}

export async function logout(): Promise<void> {
  await apiClient.post("/auth/logout");
}

export function googleLoginUrl(): string {
  return "/api/auth/google";
}

export async function loginWithPassword(email: string, password: string): Promise<AuthUser> {
  const { data } = await apiClient.post<{ user: AuthUser }>("/auth/login", { email, password });
  return data.user;
}

export async function fetchAuthConfig(): Promise<{ googleEnabled: boolean }> {
  const { data } = await apiClient.get<{ googleEnabled: boolean }>("/auth/config");
  return data;
}
